import { isDmrReactUrlEnabled } from 'reactApp/appHelpers/featuresHelpers';

export const getABReactPaymentLink = (url: string) => {
    if (!isDmrReactUrlEnabled) {
        return url;
    }

    return url?.replace(/\/\/pw\.money\.mail\.ru\/pw\/[\d-]+\//, '//checkout.vkpay.io/');
};
